import { render, staticRenderFns } from "./bottomTip.vue?vue&type=template&id=f3b931f2&scoped=true&"
import script from "./bottomTip.vue?vue&type=script&lang=js&"
export * from "./bottomTip.vue?vue&type=script&lang=js&"
import style0 from "./bottomTip.vue?vue&type=style&index=0&id=f3b931f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_6e5aa5d092232e034912f9a422cd0645/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b931f2",
  null
  
)

export default component.exports